import {Card} from 'antd';
import React from 'react';
import styled from 'styled-components';

import {margins} from '../commonProps';
import {IRaiseCardProps} from './RaiseCard.types';

const RaiseCard = styled(
  ({
    marginLeft,
    marginRight,
    marginTop,
    marginBottom,
    margin,
    gridArea,
    borderColor,
    disabled,
    ...props
  }: IRaiseCardProps) => <Card {...props} />,
)`
  && {
    ${({gridArea}) => gridArea && `grid-area: ${gridArea};`}
    ${({borderColor}) => borderColor && `border-color: ${borderColor};`};
    ${margins}
    border-radius: 7px;
    ${({disabled}) =>
      disabled &&
      `pointer-events: none;
    opacity: 0.6;
    color: #8C8C8C;`}
  }
`;

export default RaiseCard;
